"use strict";

exports.__esModule = true;
exports.isMobileSafari = isMobileSafari;

function isMobileSafari() {
  return /iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/scroll-behavior/lib/utils.js
 ** module id = 3831
 ** module chunks = 0
 **/